/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map, catchError, tap} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {APP_CONFIG} from '../app.config';
import {MessageService} from "./message.service";
import {GmPerson} from "../model/GmPerson";
import {Observable, of} from "rxjs";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class GmPersonService {


  private gmPersonUrl;


  constructor(private http: HttpClient,
              private messageService: MessageService) {
    this.gmPersonUrl = inject(APP_CONFIG).baseUrl + '/api';
  }


  getGmPerson(gmPerson: GmPerson | number): Observable<GmPerson> {
    const id = typeof gmPerson === 'number' ? gmPerson : gmPerson.gmPersonID;
    const url = `${this.gmPersonUrl}/gmpersons/${id}`;

    return this.http.get<GmPerson>(url, httpOptions).pipe(
      tap(_ => this.log('got gmPerson "${gmPerson}"')),
      catchError(this.handleError<GmPerson>('getGmPerson'))
    );
  }

  addGMPerson(gmPerson: GmPerson): Observable<GmPerson>{
    const url = `${this.gmPersonUrl}/gmpersons`;

    return this.http.post(url,gmPerson,httpOptions).pipe(
      map(gmPerson => gmPerson as GmPerson));
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a message with the MessageService */
  private log(message: string) {
    this.messageService.add('GmPerson: ' + message);
  }
}
